import { useLocation, useRouterState } from "@tanstack/react-router";
import { appBannerFor } from "@/lib/links/open-in-app";
import { currentOrigin, currentUserAgent } from "@/lib/host/request";

/** Apple's Smart App Banner on the signed-in app's pages, rendered on the server, where Safari
    reads it. A signed-out visit shows it only until the page moves to /login. */
export function AppStoreBanner() {
  const signedIn = useRouterState({
    select: (state) => state.matches.some((match) => match.routeId === "/_authenticated"),
  });
  const href = useLocation({ select: (location) => location.href });
  const content = appBannerFor({
    signedIn,
    origin: currentOrigin(),
    href,
    userAgent: currentUserAgent(),
  });
  return content ? <meta name="apple-itunes-app" content={content} /> : null;
}
